import React from 'react'
import PodcastsIcon from '@mui/icons-material/Podcasts'

import AdminMediaModal from './AdminMediaModal'
import { AdminPodcastModalStyle } from '../styles'
import { deletePodcast, updatePodcast } from '../../reducers/podcastsReducer'

const config = {
    Icon: PodcastsIcon,
    style: AdminPodcastModalStyle,
    subKey: 'sub_podcasts',
    idPrefix: 'podcast',
    formLabel: 'Podcast details',
    rowsNoun: 'talks',
    rowsHeading: 'Talks',
    rowLabel: 'Talk',
    update: updatePodcast,
    remove: deletePodcast,
}

const AdminPodcastModal = (props) => <AdminMediaModal config={config} {...props} />

export default AdminPodcastModal
